export default __webpack_public_path__ + "static/media/materialbatch.5aec4399.png";